import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const LayoutContext = createContext();

export function useLayout() {
  return useContext(LayoutContext);
}

const DEFAULTS = {
  primary: '#1a9458',
  accent: '#f0a500',
  bg: '#faf8f3',
  text: '#1a1c1f',
  card: '#f2eee5',
  navHeight: 72,
  navShadow: true,
  cardRadius: 10,
  maxWidth: 1280,
  siteName: 'Strixly',
  heroTitle: 'Entdecke unsere Rezeptsammlung',
  heroSub: 'Dein Kühlschrank. Dein Rezept. Sofort.',
  heroBtnText: 'Alle Rezepte',
  footerText: `© ${new Date().getFullYear()} Strixly`,
  fontDisplay: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontBody: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  showHero: true,
  showSearch: true,
  showFilters: true,
  showFooter: true,
  imgLogo: null,
  imgNavBg: null,
  imgHeroBg: null,
  imgPageBg: null,
  customCSS: '',
};

function applyCSSVars(cfg) {
  const root = document.documentElement;
  root.style.setProperty('--nav-height', cfg.navHeight + 'px');
  root.style.setProperty('--card-radius', cfg.cardRadius + 'px');
  root.style.setProperty('--max-width', cfg.maxWidth + 'px');

  // Custom CSS injizieren
  let styleEl = document.getElementById('cms-custom-css');
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = 'cms-custom-css';
    document.head.appendChild(styleEl);
  }
  styleEl.textContent = cfg.customCSS || '';

  // Seiten-Hintergrund
  if (cfg.imgPageBg) {
    document.body.style.backgroundImage = `url(${cfg.imgPageBg})`;
    document.body.style.backgroundSize = 'cover';
  } else {
    document.body.style.backgroundImage = '';
  }

}

export function LayoutProvider({ children }) {
  const [globalCfg, setGlobalCfg] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadGlobalLayout(); }, []);

  async function loadGlobalLayout() {
    try {
      const data = await api.getLayout('__global__');
      if (data.layout && data.layout.layout_json) {
        const merged = { ...DEFAULTS, ...data.layout.layout_json };
        setGlobalCfg(merged);
        applyCSSVars(merged);
      } else {
        applyCSSVars(DEFAULTS);
      }
    } catch {
      applyCSSVars(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }

  return (
    <LayoutContext.Provider value={{ globalCfg, loading, reload: loadGlobalLayout }}>
      {children}
    </LayoutContext.Provider>
  );
}
